import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_UPLOAD_DOCTOR_STAMP_SIGNATURE } from "../../action-types/actions";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const uploadDoctorStampSignature = createAsyncThunk(
  ACTIONS_UPLOAD_DOCTOR_STAMP_SIGNATURE.upload_stamp_signature,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.uploadDoctorStampSignature}`,
        payload,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        // Use localized success message
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);

        return response.data;
      } else {
        // Use localized error message
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);

        return rejectWithValue(response.data);
      }
    } catch (error) {
      // Use localized error message
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);

      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
